// Updated api.js - Adjusted for new backend endpoints (DELETE + JSON for deletes, POST + JSON for contact toggle)
import axios from 'axios';

const API_BASE = 'https://www.elshroukexhibition.com/backend/api';

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Auth
export const login = (credentials) => api.post('/auth.php', credentials);
export const checkAuth = () => api.get('/auth.php');

// Products
export const getProducts = (params) => api.get('/products.php', { params });
export const addProduct = (formData) => {
    return api.post('/add_product.php', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const updateProduct = (formData) => {
    return api.post('/update_product.php', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const deleteProduct = (id) => {
    return api.delete('/delete_product.php', { data: { id } });
};

// Brands
export const getBrands = () => api.get('/brands.php');
export const addBrand = (formData) => {
    return api.post('/add_brand.php', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const updateBrand = (formData) => {
    return api.post('/update_brand.php', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const deleteBrand = (id) => {
    return api.delete('/delete_brand.php', { data: { id } });
};

// Contact Requests
export const getContactRequests = () => api.get('/contact_requests.php');
export const updateContactRequest = (id) => {
    return api.post('/update_contact_request.php', { id });
};